import React, { useContext } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import classes from './CollectionCard.module.scss';
import t from '@/utils/Language/Collection-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { modalContext } from '@/context/modal.context';
import Link from '@/helpers/Link';
import { collectionHelpers } from '@/utils/helpers';
import { Button } from '@/components';
import AddToCollectionButton from '@/components/AddToCollectionButton/AddToCollectionButton';

const CollectionCard = ({
  collection,
  collectionsList,
  agencyConfiguration,
  teamsList,
  onUpdateCollection,
  onDeleteCollection,
  removeItemFromCollection,
  ...props
}) => {
  const modal = useContext(modalContext);

  const openEditCollectionModal = () => {
    modal.enqueueModal({
      name: 'NewAndEditCollectionModal',
      editCollection: true,
      agencyConfiguration: agencyConfiguration,
      collection: collection,
      teamsList: teamsList,
      onUpdateCollection: onUpdateCollection,
      onDeleteCollection: onDeleteCollection
    });
  };

  const displayEditCollectionLink = (collection) => {
    return collectionHelpers.decodePermission(collection);
  };

  return (
    <>
      <Card className={classes.collectionResource}>
        <Card.Body>
          <Row>
            <Col xs="12" className={classes.contentSection}>
              <span data-cy="card-collection-resource-count">
                {t('Collection')} - {collectionHelpers.totalResources(collection)}{' '}
                {collectionHelpers.totalResources(collection) > 1 ? t('resources') : t('resource')}
              </span>
              {['owner', 'editor'].includes(displayEditCollectionLink(collection)) ? (
                <button data-cy="card-collection-button-edit" className={`btn ${classes.configCollection}`} onClick={openEditCollectionModal}>
                  <FontAwesomeIcon icon={['fas', 'cog']} />
                </button>
              ) : (
                <AddToCollectionButton
                  resource={{ ...collection, resource_type: 'Collection' }}
                  additionalClasses={classes.configCollection}
                  onChange={onDeleteCollection}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col xs="12" className={classes.cardBody}>
              <Link href={`/collections/${collection.slug}`} data-cy="card-collection-name" className={classes.collectionLink}>
                {collection.title}
              </Link>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col xs="12" md="6">
              <p className={classes.contentSection} data-cy="card-collection-author">
                {t('By')} {collection.author}
              </p>
            </Col>
            {removeItemFromCollection && (
              <Col xs={12} md={6} className={[`${classes.cardRemoveButtons}`]}>
                <Button
                  type="link"
                  text={t('Remove from collection')}
                  styles={{ color: 'red' }}
                  onButtonClick={removeItemFromCollection}
                  additionalClasses={classes.removeResourceButton}
                />
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

CollectionCard.propTypes = {};

CollectionCard.defaultProps = {};

export default CollectionCard;
